import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';

import { withApi } from 'hcla-web-frontend-primitives/app/components/primitives/Context/ApiContext';

import { TreeNames } from './TreeDictionaries';
import HCLTreeMxGraph from '../../../../../mxGraph/HCLTreeMxGraph/HCLTreeMxGraph';
// @ts-ignore
import HCLTreeVertex from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertex';
import FullScreenDialog from '../../../../Primitives/FullScreenDialog';
import HCLModelType, {HCLModelTagTypeKey} from '../../../HCLModelTypes';
import NewHCLModel from '../../../../Generic/NewHCLModel';
import ToolboxButton from './ToolboxButton';
import FaultTreeTransferGateVertexValue from '../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeTransferGateVertexValue';
import FaultTreeTransferGateVertex from '../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeTransferGateVertex';
import Label from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label";
import Formula from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Formula";
import ReferenceTypes from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ReferenceTypes";
import ProxyType from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes";
import TransferGateIcon from "../../../../../assets/icons/TransferGateIcon";
import FaultTreeInstanceTransferGateVertex
  from "../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeInstanceTransferGateNode/FaultTreeInstanceTransferGateVertex";


export interface NewHCLModelButtonProps {
  graph: HCLTreeMxGraph;
  type: HCLModelType;
  disabled: boolean;
}

interface State {
  dialogOpen: boolean;
  saving: boolean;
}

class NewHCLModelButton extends React.Component<NewHCLModelButtonProps, State> {
  constructor(props: NewHCLModelButtonProps) {
    super(props);
    this.state = {
      dialogOpen: false,
      saving: false,
    };
  }

  private handleSubmit = (payload: any) => {
    const { type: { tag }, apiManager } = this.props;
    const isTransferGate = tag === HCLModelTagTypeKey.TRANSFER_GATE;
    payload.tag = tag;
    apiManager.postNewModel(JSON.stringify(payload))
      .then(response => response.status === 201 && response.json())
      .then((created) => {
        const { title, description, overview_tree } = created;
        const link: Formula = new Formula({
          reference_type: ReferenceTypes.GATES,
          tree_id: overview_tree,
          name: 'TOP',
          _proxy: ProxyType.EVENT_REFERENCE,
        });
        const value = new FaultTreeTransferGateVertexValue(new Label(title, description), link);
        if (isTransferGate) {
          this.addVertexWithUniqueKey(FaultTreeInstanceTransferGateVertex, value);
        } else {
          this.addVertexWithUniqueKey(FaultTreeTransferGateVertex, value);
        }
        this.setState({ dialogOpen: false });
      });
  };

  private handleCancel = () => {
    this.setState({ dialogOpen: false });
  };

  private addVertexWithUniqueKey = (vertex: any, vertexValue: FaultTreeTransferGateVertexValue) => {
    const { graph } = this.props;
    const model = graph.getModel();
    const selectedCells = graph.getSelectionCells() as HCLTreeVertex[];
    try {
      model.beginUpdate();
      const newCell = graph.addVertexWithUniqueKey(new vertex(null, vertexValue));
      selectedCells.forEach((selectedCell) => {
        if (selectedCell instanceof HCLTreeVertex) {
          selectedCell.onRequestConnectChildVertex(newCell);
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      graph.applyDefaultLayout();
      model.endUpdate();
    }
  };

  private handleFaultTreeTransferGateClick = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ dialogOpen: true });
  };

  /**
   * @throws An error if treeName is not in {@link TreeNames}
   */
  render() {
    const { disabled, type: { name, tag } } = this.props;
    const { dialogOpen } = this.state;
    const isTransferGate = tag === HCLModelTagTypeKey.TRANSFER_GATE;
    return (
      <React.Fragment>
        <ToolboxButton
          key={name}
          label={name}
          icon={isTransferGate ? <TransferGateIcon /> : tag}
          onClick={this.handleFaultTreeTransferGateClick}
          disabled={disabled}
        />
        <FullScreenDialog open={dialogOpen}>
          <NewHCLModel
            cardHeader={(
              <CardHeader
                avatar={tag}
                title={name}
                titleTypographyProps={{
                  variant: 'h5',
                }}
              />
            )}
            onSubmit={this.handleSubmit}
            onCancel={this.handleCancel}
          />
        </FullScreenDialog>
      </React.Fragment>
    );
  }
}

export default withApi(NewHCLModelButton);
